import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

export default function ProcessRecordModal({openModal, setOpenModal, validRecords, processValidRecords}) {

  const handleProceed = () => {
    setOpenModal(false);
    processValidRecords();
  };

  return (
    <Dialog
      open={openModal}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <DialogTitle id="confirmation-dialog-title" sx={{ textDecoration: "bold" }}>
        Proceed with valid records?
      </DialogTitle>
      <DialogContent>
        {validRecords} records will be processed. Only valid entries will be submitted.
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenModal(false)} variant="outlined" color="primary">
          Cancel
        </Button>
        <Button onClick={handleProceed} variant="contained" color="primary" autoFocus>
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
}
